import { createFileRoute } from '@tanstack/react-router'

import { ReportClaimPageSkeleton } from '#/modules/claim/front-office/report-claim-page/report-claim-page-skeleton.tsx'
import { ReportClaimPage } from '#/modules/claim/front-office/report-claim-page/report-claim-page.tsx'
import { FRONT_OFFICE_V2_QUERY_OPTIONS } from '#/shared/front-office-v2-query-options.ts'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/(customer)/_shell/report-claim-v2/')({
  beforeLoad: ({ context }) => requirePermissions(context, ['contract.read']),
  loader: ({ context }) => {
    const { queryClient, trpc } = context
    // Fire-and-forget: only the zero-contract empty state reads this query (Qonto search params on
    // its CTA). Warming it here runs it in parallel with the blocking query below so the empty
    // state never pays a serial second fetch; not awaited, so it never delays the first paint.
    void queryClient.prefetchQuery(trpc.users.loadMyInformation.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS))
    return queryClient.ensureQueryData(
      trpc.claims.getClaimsContactInfo.queryOptions(undefined, FRONT_OFFICE_V2_QUERY_OPTIONS),
    )
  },
  pendingComponent: ReportClaimPageSkeleton,
  pendingMs: 150,
  component: ReportClaimPage,
})
